import { Injectable, inject } from '@angular/core';
import { getFunctions, httpsCallable } from '@angular/fire/functions';
import { OfficeService } from './office.service';

@Injectable({
  providedIn: 'root',
})
export class LogService {
  officeService = inject(OfficeService);
  functions = getFunctions(undefined, 'europe-west3');
  logFunction = httpsCallable(this.functions, 'log');
  uid = '';

  constructor() {
    this.uid = localStorage.getItem('uuid') ?? '';
  }

  setUid(uid: string) {
    this.uid = uid;
    localStorage.setItem('uuid', uid);
  }

  log(message: string, data: unknown = {}) {
    const message2 = '[FRONTEND] ' + this.uid + ' ' + message;
    this.logFunction({ severity: 'INFO', message: message2, jsonPayload: data }).then(result => {
      console.log('[LOGGER] log sent ' + message, data);
    });
  }

  error(message: string, data: unknown) {
    const message2 = '[FRONTEND] ' + this.uid + ' ' + message;
    this.logFunction({ severity: 'ERROR', message: message2, jsonPayload: data }).then(result => {
      console.error('[LOGGER] error sent ' + message, data);
    });
  }
}
